/* MILLENNIUM BAZAR — JS leggero, nessuna dipendenza */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };

  /* ---------- sheet (ricerca / filtri) + viewer ---------- */
  function openSheet(id) {
    var el = document.getElementById(id); if (!el) return;
    el.classList.add('is-open'); document.body.style.overflow = 'hidden';
    var f = $('[data-autofocus]', el); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeAll() {
    $$('.mb-sheet.is-open,.mb-viewer.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mb-open]'); if (o) { e.preventDefault(); openSheet(o.getAttribute('data-mb-open')); return; }
    if (e.target.closest('[data-mb-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- toast ---------- */
  var toastT;
  function toast(html) {
    var t = $('#mb-toast'); if (!t) return;
    t.innerHTML = html; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- carrello ---------- */
  function setCount(n) { $$('[data-mb-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); }); }
  function addToCart(id, qty) {
    return fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Errore'); }); return r.json(); })
      .then(function () { return fetch((window.routes && routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-add]'); if (!b) return;
    e.preventDefault(); if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    addToCart(b.getAttribute('data-mb-add'), 1).then(function () {
      b.classList.remove('is-busy'); b.classList.add('is-ok');
      toast('Aggiunto al carrello <a href="' + ((window.routes && routes.cart_url) || '/cart') + '">Vai al carrello</a>');
      setTimeout(function () { b.classList.remove('is-ok'); }, 1800);
    }).catch(function (err) { b.classList.remove('is-busy'); toast(err.message || 'Non disponibile'); });
  });

  /* ---------- caroselli: frecce desktop ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-rail]'); if (!b) return;
    var rail = document.getElementById(b.getAttribute('data-mb-rail')); if (!rail) return;
    var step = rail.clientWidth * 0.8 * (b.getAttribute('data-dir') === 'prev' ? -1 : 1);
    rail.scrollBy({ left: step, behavior: 'smooth' });
  });

  /* ---------- caroselli: barra di avanzamento + frecce ai limiti ---------- */
  function initRails(scope) { $$('[data-mb-railtrack]', scope).forEach(function (rail) {
    if (rail.dataset.mbInit) return; rail.dataset.mbInit = '1';
    var prog = rail.parentNode.querySelector('.mb-railprog i'), btns = $$('[data-mb-rail="' + rail.id + '"]');
    function upd() {
      var max = rail.scrollWidth - rail.clientWidth; if (max <= 2) { if (prog) prog.parentNode.style.display = 'none'; btns.forEach(function (b) { b.disabled = true; }); return; }
      var r = rail.scrollLeft / max, w = Math.max(.12, rail.clientWidth / rail.scrollWidth);
      if (prog) { prog.style.width = (w * 100) + '%'; prog.style.transform = 'translateX(' + (r * (100 / w - 100)) + '%)'; }
      btns.forEach(function (b) { b.disabled = b.getAttribute('data-dir') === 'prev' ? rail.scrollLeft < 4 : rail.scrollLeft > max - 4; });
    }
    rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd(); setTimeout(upd, 800);
  }); }
  initRails(document);

  /* ---------- reveal on scroll ---------- */
  document.documentElement.classList.add('mb-js');
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(scope) {
    var els = $$('.mb-reveal', scope);
    if (io) els.forEach(function (el) { io.observe(el); }); else els.forEach(function (el) { el.classList.add('is-in'); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  }
  initReveal(document);
  /* editor tema: le sezioni vengono ricaricate al volo → ri-inizializza */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.mb-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    initRails(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    $$('.mb-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });

  /* ---------- home: chip + griglia ---------- */
  var hg = $('[data-mb-hg]');
  if (hg) {
    var chips = $$('[data-mb-sec]', hg), items = $$('.mb-hg__item', hg), more = $('[data-mb-hg-more]', hg), none = $('[data-mb-hg-none]', hg);
    var moreTxt = more ? more.textContent : '';
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        var sec = ch.getAttribute('data-mb-sec'), n = 0;
        chips.forEach(function (c) { var on = c === ch; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
        items.forEach(function (it, i) { var show = sec === 'all' || it.getAttribute('data-sec') === sec; it.hidden = !show; if (show) { it.style.setProperty('--i', n); it.style.animation = 'none'; void it.offsetWidth; it.style.animation = ''; n++; } });
        if (more) { if (sec === 'all') { more.href = (window.routes && routes.all_products_collection_url) || '/collections/all'; more.textContent = moreTxt; } else { more.href = ch.getAttribute('data-url'); more.textContent = moreTxt + ' · ' + ch.getAttribute('data-title'); } more.hidden = n === 0; }
        if (none) none.hidden = n > 0;
        ch.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });
  }

  /* ---------- collezione: ordina + carica altri ---------- */
  var sortSel = $('[data-mb-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mb-more]'); if (!a) return;
    e.preventDefault();
    var grid = document.getElementById(a.getAttribute('data-mb-more')); if (!grid) return;
    a.textContent = 'Carico…'; a.classList.add('is-busy');
    fetch(a.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ng = doc.getElementById(grid.id);
      if (ng) $$('.mb-card', ng).forEach(function (c) { grid.appendChild(c); });
      var nm = $('[data-mb-more]', doc); var shown = $('[data-mb-shown]');
      if (shown) { var tot = shown.getAttribute('data-total'); shown.textContent = 'Mostrati ' + $$('.mb-card', grid).length + ' di ' + tot; }
      if (nm) { a.href = nm.href; a.textContent = 'Carica altri'; a.classList.remove('is-busy'); }
      else { a.remove(); }
      history.replaceState(null, '', a.href && nm ? location.href : location.href);
    }).catch(function () { a.textContent = 'Riprova'; a.classList.remove('is-busy'); });
  });

  /* ---------- prodotto ---------- */
  var gal = $('[data-mb-gal]');
  if (gal) {
    var track = $('.mb-gal__track', gal), slides = $$('.mb-gal__slide', track), dots = $$('.mb-gal__dot', gal), thumbs = $$('.mb-gal__thumb', gal), count = $('[data-mb-galcount]', gal);
    var cur = 0;
    function setCur(i) {
      cur = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i) { if (!slides[i]) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setCur(i); }
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setCur(i); }, 80); }, { passive: true });
    dots.concat(thumbs).forEach(function (d) { d.addEventListener('click', function () { goTo(Number(d.getAttribute('data-i'))); }); });
    var viewer = $('#mb-viewer');
    slides.forEach(function (s) { s.addEventListener('click', function () { var full = s.getAttribute('data-full'); if (!full || !viewer) return; $('img', viewer).src = full; viewer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
    if (viewer) viewer.addEventListener('click', function (e) { if (e.target === viewer || e.target.tagName === 'IMG') closeAll(); });

    // varianti
    var form = $('#mb-pform'), idInput = form && $('input[name="id"]', form), atc = $('#mb-atc'), price = $('[data-mb-price]'), cmp = $('[data-mb-compare]'), stock = $('[data-mb-stock]'), bbp = $('[data-mb-bbprice]'), bbb = $('[data-mb-bbbtn]');
    $$('[data-mb-variant]').forEach(function (p) {
      p.addEventListener('click', function () {
        $$('[data-mb-variant]').forEach(function (q) { q.setAttribute('aria-pressed', 'false'); });
        p.setAttribute('aria-pressed', 'true');
        var id = p.getAttribute('data-mb-variant'), pr = Number(p.getAttribute('data-price')), cp = Number(p.getAttribute('data-compare')), av = p.getAttribute('data-available') === 'true', q = Number(p.getAttribute('data-qty')), tr = p.getAttribute('data-tracked') === 'true';
        if (idInput) idInput.value = id;
        if (price) price.textContent = money(pr); if (bbp) bbp.textContent = money(pr);
        if (cmp) { if (cp > pr) { cmp.textContent = money(cp); cmp.hidden = false; } else cmp.hidden = true; }
        var state = 'ok', txt = 'Disponibile';
        if (!av) { state = 'out'; txt = 'Esaurito'; } else if (tr && q === 1) { state = 'last'; txt = 'Ultimo pezzo disponibile'; } else if (tr && q > 1 && q <= 3) { state = 'low'; txt = 'Solo ' + q + ' disponibili'; }
        if (stock) { stock.setAttribute('data-state', state); $('span', stock).textContent = txt; }
        [atc, bbb].forEach(function (b) { if (!b) return; b.disabled = !av; var s = $('span', b) || b; s.textContent = av ? (b === atc ? 'Aggiungi al carrello' : 'Aggiungi') : 'Esaurito'; });
        var mid = p.getAttribute('data-media'); if (mid) { var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === mid; }); if (k >= 0) goTo(k); }
        var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.toString());
      });
    });
    // quantità
    $$('[data-mb-step]').forEach(function (b) { b.addEventListener('click', function () { var i = $('input[name="quantity"]', form); var v = Math.max(1, (Number(i.value) || 1) + Number(b.getAttribute('data-mb-step'))); i.value = v; }); });
    // submit ajax
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); if (atc.disabled) return;
      var lbl = $('span', atc), old = lbl.textContent; lbl.textContent = 'Aggiungo…'; atc.disabled = true;
      addToCart(idInput.value, Number($('input[name="quantity"]', form).value) || 1).then(function () {
        lbl.textContent = 'Aggiunto ✓'; toast('Aggiunto al carrello <a href="' + ((window.routes && routes.cart_url) || '/cart') + '">Vai al carrello</a>');
        setTimeout(function () { lbl.textContent = old; atc.disabled = false; }, 1600);
      }).catch(function (err) { lbl.textContent = old; atc.disabled = false; toast(err.message || 'Errore'); });
    });
    if (bbb) bbb.addEventListener('click', function () { if (atc) atc.click(); });
    // buy bar: appare quando il bottone principale esce dallo schermo
    var bar = $('#mb-buybar');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting); bar.setAttribute('aria-hidden', es[0].isIntersecting ? 'true' : 'false'); }, { threshold: 0 }).observe(atc);
    }
  }
})();

/* griglia compatta (mobile) */
(function(){
  var btn=document.querySelector('[data-mb-dense]'); if(!btn) return;
  var grid=document.getElementById(btn.getAttribute('data-mb-dense')); if(!grid) return;
  var on=false; try{on=localStorage.getItem('mb-dense')==='1';}catch(e){}
  function apply(){grid.classList.toggle('mb-grid--dense',on);btn.setAttribute('aria-pressed',on?'true':'false');}
  apply();
  btn.addEventListener('click',function(){on=!on;apply();try{localStorage.setItem('mb-dense',on?'1':'0');}catch(e){}});
})();

/* ---------- carrello: aggiornamento senza reload ---------- */
(function () {
  var root = document.querySelector('[data-mb-cart]'); if (!root) return;
  var sectionId = root.getAttribute('data-section'), busy = false, noteT;
  function refresh() {
    return fetch((window.routes && routes.cart_url || '/cart') + '?sections=' + sectionId, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[sectionId]; if (!html) { location.reload(); return; }
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-mb-cart]'); if (!fresh) { location.reload(); return; }
        root.innerHTML = fresh.innerHTML;
        return fetch((window.routes && routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-mb-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-n', c.item_count); });
        });
      });
  }
  function change(line, qty) {
    if (busy) return; busy = true;
    var li = root.querySelector('.mb-line[data-line="' + line + '"]'); if (li) li.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(refresh).catch(function () { location.reload(); })
      .then(function () { busy = false; });
  }
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mb-line-step]');
    if (step) {
      var li = step.closest('.mb-line'), inp = li.querySelector('[data-mb-line-qty]');
      var q = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(step.getAttribute('data-mb-line-step'), 10));
      change(parseInt(li.getAttribute('data-line'), 10), q); return;
    }
    var rm = e.target.closest('[data-mb-line-remove]');
    if (rm) { change(parseInt(rm.closest('.mb-line').getAttribute('data-line'), 10), 0); }
  });
  root.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-mb-line-qty]'); if (!inp) return;
    change(parseInt(inp.closest('.mb-line').getAttribute('data-line'), 10), Math.max(0, parseInt(inp.value, 10) || 0));
  });
  root.addEventListener('input', function (e) {
    var n = e.target.closest('[data-mb-note]'); if (!n) return;
    clearTimeout(noteT); noteT = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
    }, 600);
  });
})();
